import { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Axios from "middleware/axiosInstance";
import { Row, Col } from "antd";
import "antd/dist/antd.css";
import useAxios from "middleware/useAxios";
import queryString from "query-string";
import { Button, Form, Input, Select, Space } from "antd";

import "react-modern-calendar-datepicker/lib/DatePicker.css";
// import DatePicker, { Calendar } from "react-modern-calendar-datepicker";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
// import moment from "moment";
import Icon from "react-multi-date-picker/components/icon";
import LoadingForButton from "layouts/Loading/Loading";
import ButtonComponent from "components/Form/ButtonComponent";
import { convertToMiladi, convertToShamsi } from "utils/dateCoverter";

const { Option } = Select;
const { TextArea } = Input;

const EditeWarehouseDocument = () => {
  // start react router url params
  const UrlParams = useParams();
  const docType = UrlParams.type === "entry" ? "import" : "export";
  // end react router url params
  console.log(docType);
  // return the location object to parse url with useLocation
  const { search } = useLocation();
  // get query string to get user info
  const UrlQueryString = queryString.parse(search);

  const docId = UrlQueryString.DocId;
  console.log(docId);

  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [dayOfDoc, setDayOfDoc] = useState(null);
  const [timeOfDoc, setTimeOfDoc] = useState(null);
  const [currentDocInfo, setCurrentDocInfo] = useState(null);
  const [selectedWarehouseId, setSelectedWarehouseId] = useState(null);

  const [allWarehouse] = useAxios({
    method: "get",
    url: "/anbar",
  });
  const [allPeople] = useAxios({
    method: "get",
    url: "/people",
  });

  const [allCommodity] = useAxios({
    method: "GET",
    url: "/commodity",
  });

  const [newWarehouseEntryDocument, setNewWarehouseEntryDocument] = useState(
    {}
  );
  const getDocInfo = () => {
    Axios.get(`/${docType}/${docId}`)
      .then((res) => {
        // const dateInShamsi = convertToShamsi(res.data.date)
        // const dateInMiladi = res.data.date
        const dateInShamsi = res.data.date;
        const dateInMiladi = convertToMiladi(res.data.date);
        setCurrentDocInfo({ ...res.data, date: null });
        setDayOfDoc({
          shamsi: dateInShamsi,
          miladi: dateInMiladi,
        });
        setTimeOfDoc(res.data.time);
        setSelectedWarehouseId(res.data.anbar_id);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleFormValuesChange = (changedValues) => {
    console.log(changedValues);
    // const temp = changedValues;
    // temp.date = dayOfDoc.miladi;
    // temp.time = timeOfDoc;
    // console.log(temp);
  };
  const handleFormSubmit = async (editedData) => {
    console.log(editedData);
    editedData.date = await dayOfDoc.miladi;
    editedData.time = await timeOfDoc;
    console.log(editedData);
    Axios.put(`/${docType}/${docId}`, editedData)
      .then((res) => {
        console.log(res);
        navigate(
          `/warehouse/warehouse-documents/${
            docType === "import" ? "entry" : "exit"
          }`
        );
      })
      .catch((res) => {
        console.log(res);
      });
  };

  const changeDateAndTimeOfDocHandler = (e) => {
    const time = `${e.hour}:${e.minute}`;
    console.log(time);
    setTimeOfDoc(time);
    const dateInShamsi = `${e.year}-${e.month.number}-${e.day}`;
    const dateInMiladi = convertToMiladi(dateInShamsi);
    setDayOfDoc({ shamsi: dateInShamsi, miladi: dateInMiladi });
    setNewWarehouseEntryDocument({
      ...newWarehouseEntryDocument,
      date: dateInMiladi,
      time: timeOfDoc,
    });
  };
  const [currentCountOfCommodities, setCurrentCountOfCommodities] = useState(
    []
  );

  const getCommodityCurrentCount = (commodityId, rowIndex) => {
    Axios.post(`/count/${commodityId}`, {
      anbar_id: selectedWarehouseId,
    }).then((res) => {
      console.log(res.data.count);
      const temp = [...currentCountOfCommodities];
      temp[rowIndex] = { count: res.data.count };
      setCurrentCountOfCommodities(temp);
      console.log(temp);
      // const response = res.data.count
      // setCurrentCountOfCommodities({ ...currentCountOfCommodities, [rowIndex]: response })
    });
  };

  // useEffect(() => {
  //   getCommodityCurrentCount();
  // }, [selectedWarehouseId]);

  useEffect(() => {
    getDocInfo();
  }, []);
  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">
          ویرایش سند
          <span>{docType === "import" ? " ورود " : " خروج "}</span>
          انبار
        </h5>

        {/* <h1>
          {moment.from("1401/08/05", "fa", "YYYY/MM/DD").format("YYYY/MM/DD")}
        </h1>
        <h1>
          {moment("2022/10/27", "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD")}
        </h1> */}
        {currentDocInfo ? (
          <Form
            // layout="horizental"
            layout="vertical"
            // layout="inline"
            // {...formItemLayout}
            // layout={
            //     "span": 12,
            //     "offset": 12,
            //   },
            initialValues={currentDocInfo}
            // {
            //   {
            //     items: [{ unitValue: "", eachPrimaryUnitEqualTo: "" }],
            //     features: [{ feature: "", feature_value: "0" }]
            //   }
            // }
            form={form}
            onValuesChange={handleFormValuesChange}
            autoComplete="off"
            scrollToFirstError
            labelCol={{ xs: 24 }}
            onFinish={handleFormSubmit}
          >
            <Row gutter={8}>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  // onChange={handleFormValuesChange}
                  label={docType === "import" ? "انبار ورود" : "انبار خروج"}
                  name="anbar_id"
                  rules={[
                    {
                      required: true,
                      message: "انتخاب انبار الزامی می باشد",
                    },
                  ]}
                >
                  <Select
                    onChange={(id) => setSelectedWarehouseId(id)}
                    // className={`${classNames.classes}`}
                    loading={!allWarehouse?.[0]}
                    showSearch
                    // style={{
                    //   width: 200,
                    // }}
                    // onChange={test}
                    fieldNames="anbar_id"
                    placeholder="انتخاب فرمایید"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.includes(input)
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    id="anbar_id"
                  >
                    {allWarehouse?.map((wareHouse) => {
                      return (
                        <Option key={wareHouse.id} value={wareHouse.id}>
                          {wareHouse.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item label="شماره سند" name="sh_sanad">
                  <Input placeholder="12345" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item label="شماره عطف" name="sh_atf">
                  <Input placeholder="12345" />
                </Form.Item>
              </Col>
              {/* <Col xs={12} sm={8} md={4}> */}
              <Col xs={24} sm={12} md={8} xl={6}>
                {/* <Form.Item label="تاریخ" name="date">
                < Calendar
                  value={selectedDay}
                  onChange={e => console.log(e)}
                  locale="fa" />
              </Form.Item> */}
                <Form.Item label="تاریخ" name="date">
                  <Input
                    // value={
                    //   dayOfDoc
                    //     ? `${timeOfDoc} ${dayOfDoc.shamsi}`
                    //     : "انتخاب تاریخ"
                    // }
                    disabled
                    placeholder={
                      dayOfDoc
                        ? `${timeOfDoc} ${dayOfDoc.shamsi}`
                        : "انتخاب تاریخ"
                    }
                    addonBefore={
                      <DatePicker
                        // value={newWarehouseEntryDocument.date}
                        onChange={(e) => changeDateAndTimeOfDocHandler(e)}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-left"
                        format="HH:MM"
                        plugins={[<TimePicker hideSeconds />]}
                        render={
                          <Icon
                            style={{
                              color: "gray",
                              width: "23px",
                            }}
                          />
                        }
                      />
                    }
                  />
                </Form.Item>
              </Col>
              {/* <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item label="ساعت" name="time">
                <TimePicker
                 initialValues={moment("12:20", "HH:mm")}
                format={"HH:mm"}
                />
              </Form.Item>
            </Col> */}
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  label="شخص"
                  name="people_id"
                  rules={[
                    {
                      required: true,
                      message: "انتخاب شخص اجباری می باشد",
                    },
                  ]}
                >
                  <Select
                    // className={`${classNames.classes}`}
                    loading={!allPeople?.[0]}
                    showSearch
                    // style={{
                    //   width: 200,
                    // }}
                    // onChange={test}
                    fieldNames="people_id"
                    placeholder="انتخاب فرمایید"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.includes(input)
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    id="people_id"
                  >
                    {allPeople?.map((people) => {
                      return (
                        <Option key={people.id} value={people.id}>
                          {`${people.name} ${people.family}`}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item label="عنوان شخص" name="people_label">
                  <Input placeholder="12345" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  label="شخص دوم"
                  name="people2_id"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "انتخاب شخص اجباری است",
                  //   },
                  // ]}
                >
                  <Select
                    // className={`${classNames.classes}`}
                    loading={!allPeople?.[0]}
                    showSearch
                    // style={{
                    //   width: 200,
                    // }}
                    // onChange={test}
                    fieldNames="people2_id"
                    placeholder="انتخاب فرمایید"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.includes(input)
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    id="people2_id"
                  >
                    {allPeople?.map((people) => {
                      return (
                        <Option key={people.id} value={people.id}>
                          {`${people.name} ${people.family}`}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item name={"is_trust"} label="نوع سند">
                  <Select
                    showSearch
                    placeholder="انتخاب فرمایید"
                    optionFilterProp="children"
                  >
                    <Option value={true} >امانی</Option>
                    <Option value={false} selected={true}>قطعی</Option>
                    <Option value="null">تمام موارد</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  label="ارز"
                  name="arz"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "انتخاب شخص اجباری است",
                  //   },
                  // ]}
                >
                  <Select
                    // className={`${classNames.classes}`}
                    showSearch
                    // style={{
                    //   width: 200,
                    // }}
                    // onChange={test}
                    fieldNames="arz"
                    placeholder="انتخاب فرمایید"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.includes(input)
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    id="arz"
                  >
                    <Option value="rial">ریال</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item label="نرخ ارز" name="nerkh_arz">
                  <Input placeholder="4200" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item label="شرح" name="description">
                  <TextArea rows={4} placeholder="شرح" />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xs={24}>
                {/* start form list */}

                <Form.List name="items">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Space
                          key={key}
                          style={{ display: "flex", marginBottom: 8 }}
                          align="baseline"
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "frzd"]}
                            label="ردیف"
                          >
                            {/* row number */}
                            {name + 1}
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, "mojudi"]}
                            label="موجودی"
                          >
                            {currentCountOfCommodities[name]?.count}

                            {/* row number
                        {/* {formValues?.items[name].commodity_id &&
                            getCommodityCurrentCount(
                              formValues?.items[name].commodity_id
                            )} */}
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[
                              name,
                              docType === "import"
                                ? "commodity_id"
                                : "commodity2_id",
                            ]}
                            label="شناسه/نام کالا"
                            rules={[
                              {
                                required: true,
                                message: "انتخاب کالا اجباری است",
                              },
                            ]}
                          >
                            <Select
                              onChange={(e) => {
                                getCommodityCurrentCount(e, name, restField);
                                console.log(e, name, restField);
                              }}
                              dropdownMatchSelectWidth="false"
                              showSearch
                              loading={!allCommodity?.[0]}
                              placeholder="انتخاب فرمایید"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children.includes(input)
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {allCommodity?.map((kala) => {
                                return (
                                  <Option key={kala.id} value={kala.id}>
                                    {`${kala.id} -${kala.name}`}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                          {/* <Form.Item label="نام کالا">
                          {newWarehouseEntryDocument.items[index]?.name ? newWarehouseEntryDocument.items[index].name : null}
                        </Form.Item> */}

                          <Form.Item
                            {...restField}
                            name={[
                              name,
                              docType === "import" ? "count_im" : "count_ex",
                            ]}
                            label="تعداد"
                            rules={[
                              {
                                required: true,
                                message: "انتخاب تعداد اجباری است",
                              },
                            ]}
                          >
                            <Input placeholder="123" />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, "fi"]}
                            label="فی"
                          >
                            <Input placeholder="4200" />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, "price"]}
                            label="مبلغ"
                          >
                            <Input placeholder="4200" />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            label={docType === "import" ? "کد ورود" : "کد خروج"}
                            name={[name, "code_delivery"]}
                          >
                            <Input placeholder="4200" />
                          </Form.Item>
                          {/* <Form.Item
                          {...restField}
                          label={
                            docType === "import" ? "تاریخ ورود" : "تاریخ خروج"
                          }
                          name={[name, "date_delivery"]}
                        >
                          <Input placeholder="4200" />
                        </Form.Item> */}
                          <Form.Item
                            {...restField}
                            label="توضیحات"
                            name={[name, "description"]}
                          >
                            <Input placeholder="4200" />
                          </Form.Item>
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </Space>
                      ))}
                      <Form.Item>
                        <Button
                          type="dashed"
                          onClick={() => add()}
                          block
                          icon={<PlusOutlined />}
                        >
                          ایجاد یک ردیف جدید
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
                {/* end form list */}
              </Col>
            </Row>
            <Form.Item
            // {...buttonItemLayout}
            >
              {/* <Button
              htmlType="submit"
              type="primary"
            // onClick={CreateWarehouseEntryDocumentHandler}
            >
              ثبت
            </Button> */}
              <ButtonComponent type="submit" value="ثبت" />
            </Form.Item>
          </Form>
        ) : (
          <LoadingForButton />
        )}
      </div>
    </div>
  );
};

export default EditeWarehouseDocument;
